<div class="container-fluid">
  <!-- sign up page start-->
  <div class="authentication-main">
    <div class="row">
      <div class="col-sm-12 p-0">
        <div class="auth-innerright">
          <div class="authentication-box">
            <div class="text-center"><img src="assets/images/enplace_logo.png"
                alt></div>
            <div class="card mt-4 p-4">
              <h4 class="text-center">NEW USER</h4>
              <h6 class="text-center">Enter your Username and Password For
                Signup</h6>
              <form [formGroup]="registrationForm" class="theme-form">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="col-form-label">First Name</label>
                      <input class="form-control" type="text"
                        placeholder="John" formControlName="firstName">
                      <span
                        *ngIf="checkErrors && getFormControl('firstName')!.errors?.['required']"
                        class="text-danger">First name is
                        required.</span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="col-form-label">Last Name</label>
                      <input class="form-control" type="text" placeholder="Deo"
                        formControlName="lastName">
                      <span
                        *ngIf="checkErrors && getFormControl('lastName')!.errors?.['required']"
                        class="text-danger">Last name is
                        required.</span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-form-label">Email</label>
                  <input class="form-control" type="text"
                    placeholder="John Deo" formControlName="email">
                  <span
                    *ngIf="checkErrors && getFormControl('email')!.errors?.['required']"
                    class="text-danger">Email is
                    required.</span>
                  <span
                    *ngIf="getFormControl('email')!.value != '' && !getFormControl('email')!.value?.match(validEmailRegex)"
                    class="block text-danger">A valid email is
                    required</span>
                </div>
                <div class="form-group">
                  <label class="col-form-label">Password</label>
                  <input class="form-control" type="password"
                    placeholder="**********" formControlName="password">
                  <span
                    *ngIf="checkErrors && getFormControl('password')!.errors?.['required']"
                    class="text-danger">Password is
                    required.</span>
                  <ul class="text-red-400 text-sm mt-2"
                    *ngIf=" getFormControl('password')?.dirty">
                    <li class="block"
                      [ngClass]="{'text-success':  getFormControl('password')?.value?.match('^(?=.*[A-Z])')}">
                      <i
                        *ngIf=" getFormControl('password')?.value?.match('^(?=.*[A-Z])')"
                        class="fa fa-check"></i> At least one uppercase
                      letter.</li>
                    <li class="block"
                      [ngClass]="{'text-success':  getFormControl('password')?.value?.match('(?=.*[a-z])')}">
                      <i
                        *ngIf=" getFormControl('password')?.value?.match('(?=.*[a-z])')"
                        class="fa fa-check"></i> At least one lowercase
                      letter.</li>
                    <li class="block"
                      [ngClass]="{'text-success':  getFormControl('password')?.value?.match('(.*[0-9].*)')}">
                      <i
                        *ngIf=" getFormControl('password')?.value?.match('(.*[0-9].*)')"
                        class="fa fa-check"></i> At least one digit.</li>
                    <li class="block"
                      [ngClass]="{'text-success':  getFormControl('password')?.value?.match('(?=.*[!@#$%^&*])')}">
                      <i
                        *ngIf=" getFormControl('password')?.value?.match('(?=.*[!@#$%^&*])')"
                        class="fa fa-check"></i> At least one special
                      character.</li>
                    <li class="block"
                      [ngClass]="{'text-success':  getFormControl('password')?.value?.match('.{8,}')}">
                      <i
                        *ngIf=" getFormControl('password')?.value?.match('.{8,}')"
                        class="fa fa-check"></i> At least 8 characters
                      long.</li>
                  </ul>
                </div>
                <div class="form-group">
                  <label class="col-form-label">Verify Password</label>
                  <input class="form-control" type="password"
                    placeholder="**********" formControlName="password2">
                  <span
                    *ngIf="checkErrors && getFormControl('password2')!.errors?.['required']"
                    class="text-danger">Password verification is
                    required.</span>
                  <span class="block text-danger"
                    *ngIf="!isPasswordConfirmed">
                    Password does'nt match.
                  </span>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <button class="btn btn-primary" (click)="register()">Sign
                      Up</button>
                  </div>
                  <div class="col-sm-8">
                    <div class="text-start mt-2 m-l-20">Are you already an user?
                      <a
                        href="javascript:void(0)"
                        class="btn-link text-capitalize"
                        (click)="goToLogin()">Login</a></div>
                  </div>
                </div>
                <div class="form-divider"></div>
                <div class="social mt-3">
                  <div class="form-group btn-showcase d-flex">
                    <button class="btn social-btn btn-fb d-inline-block"> <i
                        class="fa fa-facebook"></i></button>
                    <button class="btn social-btn btn-twitter d-inline-block"><i
                        class="fa fa-google"></i></button>
                    <button class="btn social-btn btn-google d-inline-block"><i
                        class="fa fa-twitter"></i></button>
                    <button class="btn social-btn btn-github d-inline-block"><i
                        class="fa fa-github"></i></button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- sign up page ends-->
</div>